import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Icon } from '@ibk/shared-ui';
import styles from './Item.module.css';
const Item = ({ text, dataTestid }) => {
    return (_jsxs("div", { className: styles.item, "data-testid": dataTestid, children: [_jsx(Icon, { name: 'checkMarkCircle', className: styles.icon }), _jsx("div", { className: styles.text, children: text })] }));
};
const SimpleOperatorDetails = ({ description, items, dataTestid }) => {
    const renderItems = useCallback(() => items.map((item, i) => _jsx(Item, { text: item, dataTestid: `${dataTestid}.item.#${i}` }, item + i)), [items, dataTestid]);
    return (_jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.description, "data-testid": `${dataTestid}.description`, children: description }), renderItems()] }));
};
export default SimpleOperatorDetails;
